import gql from 'graphql-tag';

import { apolloProvider } from '../../../vueApollo';
import { MUT_ERR_WALLETS, MUT_GET_WALLETS, MUT_SET_WALLETS } from './types';

const nameCollator = new Intl.Collator(undefined, { sensitivity: 'base' });

const state = () => ({
  /** @type {import('../../../api-svc-types').Wallet[] | undefined} */
  wallets: undefined,
  /** @type {boolean | null | undefined} */
  isLoading: null,
});

const getters = {
  WALLETS: (state) => {
    return state.wallets;
  },
  WALLETS_ISLOADING: (state) => {
    return state.isLoading;
  },
};

// Sequence number of the most recent request; see the action.
let latestRequest = 0;

const actions = {
  async getWallets({ commit, rootState }, orgId) {
    const client = apolloProvider.clients.defaultClient;
    // Requests overlap when the org changes mid-flight (the user switches, or the v3 shell
    // corrects the org this window booted on). The NEWEST request owns this module's data
    // and loading flag: an older response never touches them, and the newest one only
    // lands if its org is still current — otherwise it clears rather than leaves another
    // org's data on screen. CIB-4184.
    const request = ++latestRequest;
    const isLatest = () => request === latestRequest;
    const stillCurrent = () => rootState.currentOrg?.id === orgId;
    commit(MUT_GET_WALLETS);
    try {
      const res = await client.query({
        query: gql`
          query GetWallets($orgId: ID!) {
            wallets(orgId: $orgId) {
              id
              name
              description
              type
              deviceType
              networkId
              address
              addresses
              path
              enabledCoins
              subsidiaryId
            }
          }
        `,
        variables: {
          orgId,
        },
        fetchPolicy: 'network-only',
      });
      if (!isLatest()) return;
      if (!stillCurrent()) {
        commit(MUT_ERR_WALLETS);
        return;
      }
      commit(MUT_SET_WALLETS, res.data.wallets);
    } catch (e) {
      if (!isLatest()) return;
      commit(MUT_ERR_WALLETS);
    }
  },
};

const mutations = {
  [MUT_GET_WALLETS](state) {
    state.isLoading = true;
  },
  [MUT_SET_WALLETS](state, wallets) {
    // name A–Z, so every picker reading this getter lists them that way
    state.wallets = wallets ? [...wallets].sort((a, b) => nameCollator.compare(a.name ?? '', b.name ?? '')) : wallets;
    state.isLoading = false;
  },
  [MUT_ERR_WALLETS](state) {
    state.wallets = undefined;
    state.isLoading = false;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
